import * as _ from "../../../util/lodash";
import React from 'react';
import { createComponent, PropTypes } from "../../../wayin-react";
import { whitelistStyles } from "../hoc";
import classnames from 'classnames';
import { positions, icons, sizes } from "../../../enums";
import color from 'color';
import { ChromePicker } from 'react-color';
import Label from "../label";
import Input from "../input";
import Icon from "../icon";
import Tooltip from "../tooltip";
import validators from "../../../validators";
import ColorSwatch from "../../abstractions/color-swatch"; // Color picker has its own internal 'isColor' validation

var ColorPicker = createComponent({
  displayName: 'ColorPicker',
  PropTypes: {
    value: PropTypes.string,
    id: PropTypes.oneOf([PropTypes.string, PropTypes.number]),
    position: PropTypes.oneOf([positions.TOP_LEFT, positions.TOP_RIGHT, positions.BOTTOM_LEFT, positions.BOTTOM_RIGHT]),
    label: PropTypes.string,
    showClearIcon: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    isCompact: PropTypes.bool,
    hasInput: PropTypes.bool,
    onHidePicker: PropTypes.func,
    onShowPicker: PropTypes.func
  },
  defaultProps: {
    value: undefined,
    id: undefined,
    position: positions.BOTTOM_RIGHT,
    showClearIcon: false,
    label: undefined,
    isCompact: true,
    hasInput: true,
    onHidePicker: _.noop,
    onShowPicker: _.noop
  },
  contextTypes: {
    isInverted: PropTypes.bool
  },
  lifecycles: {
    UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
      var currentColor;

      if (!!this.props.value && validators.isColor()(this.props.value) === true) {
        var rgb = getRGB(this.props.value);
        currentColor = getColorForCurrentView(this.props.currentView, rgb);
      }

      this.props.setCurrentColor(currentColor);
    },
    UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (!this.props.isPickerVisible && nextProps.isPickerVisible) {
        document.addEventListener('click', this.props.handleDocumentClick);
        document.addEventListener('keydown', this.props.handleKeyDown);
      } else if (this.props.isPickerVisible && !nextProps.isPickerVisible) {
        document.removeEventListener('click', this.props.handleDocumentClick);
        document.removeEventListener('keydown', this.props.handleKeyDown);
      } // only coerce color to new view type if it is a valid color
      // if not a valid color, leave value as is, which is the only case
      // where the input and picker view types could be out of sync


      if (nextProps.isPickerVisible) {
        if (this.props.currentView === 'hex' && nextProps.currentView === 'rgb') {
          var colorString = validators.isColor()(nextProps.value) === true ? getCleanColor(nextProps.value).rgb().string() : nextProps.value;
          this.props.setCurrentColor(colorString);
        }

        if (this.props.currentView === 'rgb' && nextProps.currentView === 'hex') {
          var rgbObj = !!nextProps.value && !isShortHex(nextProps.value) && validators.isColor()(nextProps.value) === true && getCleanColor(nextProps.value).object();

          var _colorString = !!rgbObj ? rgbToHex(rgbObj) : nextProps.value;

          this.props.setCurrentColor(_colorString);
        }
      }

      if (this.props.value !== nextProps.value) {
        this.props.setCurrentColor(nextProps.value);
      }
    },
    componentWillUnmount: function componentWillUnmount() {
      document.removeEventListener('click', this.props.handleDocumentClick);
      document.removeEventListener('keydown', this.props.handleKeyDown);
    }
  },
  state: {
    isPickerVisible: {
      value: false,
      updater: function updater(_updater, props) {
        return {
          toggleColorPicker: function toggleColorPicker(e, _ref) {
            var value = _ref.value,
                id = _ref.id;
            props.isPickerVisible ? props.onHidePicker(e, {
              value: value,
              id: id
            }) : props.onShowPicker(e, {
              value: value,
              id: id
            });

            _updater(function (isPickerVisible) {
              return !isPickerVisible;
            });
          },
          hideColorPicker: function hideColorPicker(e, _ref2) {
            var value = _ref2.value,
                id = _ref2.id;
            props.onHidePicker(e, {
              value: value,
              id: id
            });

            _updater(false);
          },
          showColorPicker: function showColorPicker(e, _ref3) {
            var value = _ref3.value,
                id = _ref3.id;
            props.onShowPicker(e, {
              value: value,
              id: id
            });

            _updater(true);
          }
        };
      }
    },
    currentView: {
      value: function value(p) {
        // to sync input with initial view of picker, if color value does not have transparency, coerce to hex
        var alpha = validators.isColor()(p.value) === true ? getCleanColor(p.value).alpha() : 1;
        return !p.value || !hasTransparency(alpha) ? 'hex' : 'rgb';
      },
      updater: 'setCurrentView'
    },
    currentColor: {
      // current color represents value prop coerced to either hex or rgb depending on picker view
      value: function value(p) {
        return p.value;
      },
      updater: 'setCurrentColor'
    },
    internalErrorMessage: {
      value: '',
      updater: 'setInternalErrorMessage'
    }
  },
  refs: ['pickerRef'],
  handlers: {
    handleKeyDown: function handleKeyDown(props) {
      return function (e) {
        // enter key
        if (e.keyCode === 13) {
          props.onChange(e, {
            value: props.currentColor,
            id: props.id
          });
          props.hideColorPicker(e, {
            value: props.currentColor,
            id: props.id
          });
        } // escape key


        if (e.keyCode === 27) {
          props.hideColorPicker(e, {
            value: props.currentColor,
            id: props.id
          });
        }
      };
    },
    handleColorSelection: function handleColorSelection(props) {
      return function (value, event) {
        var color = getColorForCurrentView(props.currentView, value.rgb); //clear internal error if now valid

        if (!!props.internalErrorMessage && validators.isColor()(color) === true) {
          props.setInternalErrorMessage('');
        }

        props.setCurrentColor(color);
        props.onChange(event, {
          value: color,
          id: props.id
        });
      };
    },
    handleColorChange: function handleColorChange(props) {
      return function (e, _ref4) {
        var value = _ref4.value,
            id = _ref4.id;

        //clear internal error if now valid
        if (!!props.internalErrorMessage && validators.isColor()(value) === true) {
          props.setInternalErrorMessage('');
        }

        props.setCurrentColor(value);
        props.onChange(e, {
          value: value,
          id: id
        });
      };
    },
    handleColorClear: function handleColorClear(props) {
      return function (e, _ref5) {
        var id = _ref5.id;
        props.onChange(e, {
          value: '',
          id: id
        });
        props.setCurrentColor('');
      };
    },
    // this is called when picker view toggle is clicked, and when picker alpha is changed
    handleViewChange: function handleViewChange(props) {
      return function (view) {
        props.setCurrentView(view);
      };
    },
    handleDocumentClick: function handleDocumentClick(props) {
      return function (event) {
        var wasPickerClicked = props.refs.pickerRef.contains(event.target);
        if (wasPickerClicked) return;
        props.hideColorPicker(event, {
          value: props.currentColor,
          id: props.id
        });
      };
    },
    handleBlur: function handleBlur(props) {
      return function (ev, _ref6) {
        var id = _ref6.id,
            value = _ref6.value;
        var internalErrorMessage = validators.isColor()(value) !== true ? 'Enter a valid color' : '';
        props.setInternalErrorMessage(internalErrorMessage);
        props.onBlur && props.onBlur(ev, {
          id: id,
          value: value
        });
      };
    }
  },
  render: function render(props) {
    var _classnames;

    var rgba;

    if (validators.isColor()(props.currentColor) === true) {
      // convert string to rgb object for <ChromePicker>
      if (!!props.currentColor && props.currentColor === 'transparent') {
        rgba = props.currentColor;
      } else if (!!props.currentColor) {
        var rgb = getRGB(props.currentColor);
        rgba = {
          r: rgb.r,
          g: rgb.g,
          b: rgb.b,
          a: rgb.alpha || 1
        };
      }
    }

    return /*#__PURE__*/React.createElement("div", {
      className: classnames('ck color-picker', "color-picker--" + props.position, (_classnames = {}, _classnames['color-picker--inverted'] = props.isInverted, _classnames['color-picker--has-input'] = props.hasInput, _classnames.compact = props.isCompact, _classnames)),
      ref: props.setPickerRef,
      style: props.style
    }, props.label ? /*#__PURE__*/React.createElement(Label, {
      text: props.label
    }) : null, /*#__PURE__*/React.createElement("div", {
      className: "color-picker__positioner"
    }, props.isPickerVisible ? /*#__PURE__*/React.createElement(ChromePicker, {
      color: rgba,
      defaultView: props.currentView,
      onChangeComplete: props.handleColorSelection,
      onViewChange: props.handleViewChange
    }) : null, props.hasInput ? [/*#__PURE__*/React.createElement(Input, {
      action: {
        content: /*#__PURE__*/React.createElement(ColorSwatch, {
          value: props.currentColor,
          onClick: props.toggleColorPicker
        }),
        position: positions.LEFT
      },
      value: props.currentColor,
      onChange: props.handleColorChange,
      errorMessage: props.errorMessage || props.internalErrorMessage,
      onBlur: props.handleBlur // validatable neccessity
      ,
      placeholder: "transparent",
      id: props.id,
      key: "0"
    }), props.value && props.showClearIcon ? /*#__PURE__*/React.createElement(Tooltip, {
      tooltip: "clear current color",
      position: positions.TOP_LEFT,
      isCompact: true,
      key: "1"
    }, /*#__PURE__*/React.createElement(Icon, {
      name: icons.CANCEL,
      size: sizes.X5,
      id: props.id,
      onClick: props.handleColorClear
    })) : null] : /*#__PURE__*/React.createElement(ColorSwatch, {
      value: props.currentColor,
      onClick: props.showColorPicker,
      hasBorder: true
    })));
  }
});

function getCleanColor(value) {
  return !!value ? color(value.toLowerCase()) : color(value || 'transparent');
}

function componentToHex(component) {
  var hex = component.toString(16);
  return hex.length === 1 ? '0' + hex : hex;
}

function rgbToHex(rgbObj) {
  var alpha = rgbObj.alpha || rgbObj.a || 0; //when alpha is 0 or 1, we are not going to add it. For the rest, we are turning the 0..1 value to 0..255 and then turn it into hex

  var hexAlpha = alpha > 0 && alpha < 1 ? componentToHex(Math.floor(alpha * 255)) : '';
  return "#" + componentToHex(rgbObj.r) + componentToHex(rgbObj.g) + componentToHex(rgbObj.b) + hexAlpha;
}

function hasTransparency(colorAlpha) {
  return colorAlpha !== 1;
}

function getColorForCurrentView(view, colorObj) {
  var currentColor;

  switch (view) {
    case 'rgb':
      if (colorObj.r === 0 && colorObj.g === 0 && colorObj.b === 0 && (colorObj.alpha === 0 || colorObj.a === 0)) currentColor = 'transparent';else currentColor = "rgba(" + colorObj.r + ", " + colorObj.g + ", " + colorObj.b + ", " + (colorObj.alpha || colorObj.a) + ")";
      break;

    case 'hex':
      var hex = rgbToHex(colorObj);
      currentColor = hex;
      break;
  }

  return currentColor;
}

function getRGB(currentColor) {
  var rgbColor = color(currentColor.toLowerCase()).rgb().object();

  if (rgbColor && rgbColor.alpha) {
    //above color function can create a very long 0.1234567675 alpha value, which we want to fix to max 2 decimals
    rgbColor.alpha = Number(rgbColor.alpha.toFixed(2));
  }

  return rgbColor;
}

function isShortHex(value) {
  // simple length check is all that is needed here
  return !!value && value.length < 5;
}

export default whitelistStyles()(ColorPicker);
//# sourceMappingURL=index.js.map